import React from "react";
import { Raycaster, MeshLambertMaterial, Vector2, BoxGeometry, WebGLRenderer, PerspectiveCamera, Scene, Group, TextureLoader, Mesh, PlaneGeometry, MeshBasicMaterial, AmbientLight } from 'three';
import homePageImage from "../../assets/images/13.jpg"
import { hotspots } from "../../data/model"
import cloud from '../../assets/images/cloud.png';
import prmediauimarker from "../../assets/images/logos/PR Media UI Marker.png"
import fyponuimarker from "../../assets/images/logos/Fypon UI Marker.png"
import ttuimarker from "../../assets/images/logos/TT UI Marker.png"
import ttuimarker_border from "../../assets/images/logos/TT UI Marker_border.png"
import fyponuimarker_border from "../../assets/images/logos/Fypon UI Marker_border.png"
import prmediauimarker_border from "../../assets/images/logos/PR Media UI Marker_border.png"

// import home_view from "../../assets/images/home_view.png"

import $ from "jquery"
import { ConnectingAirportsOutlined } from "@mui/icons-material";

class HomeComponent extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: window.innerHeight,
            width: window.innerWidth,
        }
        this.needsUpdate = true;
        this.clickEaster = false;

    }


    renderCanvasScene = (e) => {
        if (!e.target.dataset.redirect) return;
        if (this.props.device === undefined && !this.props.sidebarToggle) {
            this.props.showSidebar();
        }

        let cubemap = null
        let logo = null

        switch (e.target.dataset.redirect) {
            case 'fypon':
                cubemap = "fypon_arial"
                logo = "fypon"
                break;
            case 'pr_media':
                document.querySelectorAll('.dropdown_item').forEach(element => {
                    element.style.color = "#4e4e4e"
                })
                $("#media").css("color", '#E91E23')
                cubemap = "prmedia"
                logo = ""
                break;
            default:
                cubemap = "thermatru_arial"
                logo = "thermatru"
        }
        this.props.changeRender360Map(cubemap);
    }

    animate = () => {

        if (!this.needsUpdate) return;
        requestAnimationFrame(this.animate);
        if (this.props.pageKey === 'home') {
            this.cloudParticles.forEach(p => {
                p.rotation.z -= 0.001;
                p.position.x += 0.16;
                if (p.position.x > (window.innerWidth / 2)) {
                    p.position.x = -(window.innerWidth / 2);
                }
            });
            this.renderer.render(this.scene, this.camera);
        }
    };

    createScene = () => {
        this.scene = new Scene();
        this.cloudParticles = [];
        let CloudGroup = new Group();
        this.scene.add(CloudGroup);
        this.camera = new PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.1, 1000);
        this.camera.rotation.x = 1.16;
        this.camera.rotation.y = -0.12;
        this.camera.rotation.z = 0.27;
        const container = document.getElementById('home-bg');
        this.renderer = new WebGLRenderer();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.setClearColor(0xffffff, 1);
        const textloader = new TextureLoader();
        textloader.load(homePageImage, (texture) => {
            this.scene.background = texture;
        });
        let ambient = new AmbientLight(0xffffff, 1);
        this.scene.add(ambient);
        container.appendChild(this.renderer.domElement);
        let loader = new TextureLoader();
        let that = this
        loader.load(cloud, function (texture) {
            let cloudGeo = new PlaneGeometry(100, 100);
            let cloudMaterial = new MeshLambertMaterial({
                map: texture,
                transparent: true
            });

            for (let p = 0; p < 150; p++) {
                let cloud = new Mesh(cloudGeo, cloudMaterial);
                cloud.position.set(
                    Math.random() * 1400 - 500,
                    Math.random() * 4 + 160,
                    Math.random() * 1300 - 600
                );
                cloud.rotation.x = 1.16;
                cloud.rotation.y = -0.12;
                cloud.rotation.z = Math.random() * 2 * Math.PI;
                cloud.material.opacity = 0.4;
                that.cloudParticles.push(cloud);
                CloudGroup.add(cloud);

            }
        });
        this.__loadEasterEgg();
        this.animate();

    }

    __loadEasterEgg = () => {
        const geometry = new PlaneGeometry(3, 1, 1, 1);
        const material = new MeshBasicMaterial({ side: 2, transparent: true, opacity: 0 });
        const plane = new Mesh(geometry, material);
        plane.position.set(-7.410, 20.160, -11.510);
        plane.rotation.set(0.970, 0.370, 0.820);
        plane.name = "easter-egg";
        this.scene.add(plane);
    }

    onDocumentMouseMove = (event) => {
        let mouse = new Vector2();
        mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;
        let raycaster = new Raycaster();
        raycaster.setFromCamera(mouse, this.camera);
        let intersects = raycaster.intersectObjects(this.scene.children);
        if (intersects.length > 0 && intersects[0].object.name === 'easter-egg') {
            this.clickEaster = true;
            $('html,body').css('cursor', 'pointer');
        } else {
            this.clickEaster = false;
            $('html,body').css('cursor', 'default');
        }

    }

    onDocumentMouseClick = () => {
        if (this.clickEaster && this.needsUpdate) {
            window.open("https://fiberon2023.thetunagroup.com", '_blank');
        }
    }

    loadUiImg = (title) => {

        let changeimage = null
        if (title === "Thermatru Doors") {
            changeimage = $("#thermatru").attr("src")

        } else if (title === "PR & Media") {
            changeimage = $("#prmedia").attr("src")

        } else {
            changeimage = $("#fypon").attr("src")
        }

        return changeimage;
    }

    loadUiBorderImg = (title) => {

        let changeimage = null
        if (title === "Thermatru Doors") {
            changeimage = $("#thermatru_border").attr("src")

        } else if (title === "PR & Media") {
            changeimage = $("#prmedia_border").attr("src")

        } else {
            changeimage = $("#fypon_border").attr("src")
        }

        return changeimage;

    }
    componentDidUpdate(prevProps) {

        if (prevProps.pageKey !== this.props.pageKey && this.props.pageKey === 'home') {
            this.needsUpdate = true;
            this.animate();
        }

        if (prevProps.pageKey !== this.props.pageKey && this.props.pageKey !== 'home') {
            this.needsUpdate = false;
        }
        // if(prevProps.deviceDirection !== this.props.deviceDirection && this.props.deviceDirection === 'port'){
        //     this.needsUpdate = false;
        // }

        // if(prevProps.deviceDirection !== this.props.deviceDirection && this.props.deviceDirection !== 'port'){
        //     this.needsUpdate = true;
        //     this.animate()      ;  
        // }
       
          
    }

    componentDidMount() {
        this.createScene();
        window.addEventListener('resize', () => { this.resize(); });
        window.addEventListener('mousemove', this.onDocumentMouseMove);
        window.addEventListener('click', this.onDocumentMouseClick);
        document.querySelectorAll(".uimarker").forEach((e) => {
            e.addEventListener('click', this.renderCanvasScene)
        })



        let that = this
        $(".uimarker").on('mouseenter', function (e) {

            let img = that.loadUiBorderImg(this.dataset.title)

            $(this).attr('src', img)

        })


        $(".uimarker").on('mouseleave', function (e) {


            let img = that.loadUiImg(this.dataset.title)

            $(this).attr('src', img)

        })


        $(document).on("touchstart", ".uimarker", function () {


            let img = that.loadUiBorderImg(this.dataset.title)

            $(this).attr('src', img)


        });

        $(document).on("touchend", ".uimarker", function () {


            let img = that.loadUiImg(this.dataset.title)

            $(this).attr('src', img)

        });


    }

    componentWillUnmount() {
        this.clickEaster = false;
        window.removeEventListener('resize', () => { this.resize(); });
        window.removeEventListener('mousemove', this.onDocumentMouseMove);
        window.removeEventListener('click', this.onDocumentMouseClick);
        document.querySelectorAll(".uimarker").forEach((e) => {
            e.removeEventListener('click', this.renderCanvasScene)
        })
    }

    resize = () => {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }

    render() {
        const wMark = this.state.width * 0.12, hMark = this.state.height * 0.15
        // const l = (this.state.width-w)/2
        return (
            <div className={`home wrapper back-board ${this.props.pageKey === 'home' ? 'active' : ''}`} style={{ width: this.state.width, height: this.state.height, }}>
                <div id="home-bg" className="home-item active">
                    {/* <img src={homePageImage} /> */}
                </div>
                {
                    hotspots.map((val, index) => {
                        let imgdiv = null
                        if (val.title === "Thermatru Doors") {
                            imgdiv = ttuimarker

                        } else if (val.title === "PR & Media") {
                            imgdiv = prmediauimarker

                        } else {
                            imgdiv = fyponuimarker

                        }

                        return (
                            <div className="mark-wrapper active" data-redirect={val.redirectionlink} style={{ top: val.top, left: val.left }} key={index}>
                                <div className='mark-inner' style={{ width: wMark, height: 'auto', marginTop: -hMark, marginLeft: wMark / -2 }}>
                                    <img src={imgdiv} alt='' data-redirect={val.redirectionlink} data-title={val.title} className="uimarker"></img>
                                </div>
                            </div>
                        )
                    }

                    )
                }

                <img src={ttuimarker_border} id="thermatru_border" className="d-none" />
                <img src={prmediauimarker_border} id="prmedia_border" className="d-none" />
                <img src={fyponuimarker_border} id="fypon_border" className="d-none" />
                <img src={ttuimarker} id="thermatru" className="d-none" />
                <img src={prmediauimarker} id="prmedia" className="d-none" />
                <img src={fyponuimarker} id="fypon" className="d-none" />


            </div>
        )
    }
}



export default HomeComponent;